import React from 'react';
import App from 'components/App';
import CoreLayout from 'components/CoreLayout';
import { createBrowserRouter } from 'react-router';

import HomeRoute from './Home';
import LocaleRoute from './Locale';
import GiftRoute from './Gift';

const createRoutes = createBrowserRouter([
  {
    path: '/',
    ErrorBoundary: __DEV__ ? undefined : () => <></>,
    element: (
      <App>
        <CoreLayout />
      </App>
    ),
    children: [
      HomeRoute,
      GiftRoute,
      LocaleRoute
    ]
  }
]);

export default createRoutes;
